module.exports = "/images/Icon goals-Display Popup Offers & Alerts_1 1.svg?ab38ee287b668193fe86d62d56c01ca8";